// extracted by mini-css-extract-plugin
export default {"root":"Day_root__3E5zK","button":"Day_button__sCMq9"};